import { type GetServerSidePropsContext } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultServerSideProps } from '@/utils/next';
import { parseScannedCode } from './utils/parseScannedCode';
import { CodeLoginPageView } from './CodeLoginPageView';

// 루트 레이아웃(GnbHeader)을 스킵해 헤더를 숨긴다.
// 화면 중앙 정렬은 View 의 CenterLayout(fixed h-dvh justify-center)이 담당한다.
const CodeLoginPage = CodeLoginPageView as typeof CodeLoginPageView & {
  getLayout?: typeof getEmptyLayout;
};
CodeLoginPage.getLayout = getEmptyLayout;
export default CodeLoginPage;

/**
 * 진입 코드 로그인 페이지는 gSSP 로 동적 렌더링한다.
 * QR 딥링크(`?code=XXXXXXX`)로 들어오면 코드를 파싱해 초기값으로 넘겨 자동 검증을 트리거한다.
 * 유효하지 않은 코드는 빈 문자열로 정규화되어 일반 입력 폼이 노출된다.
 */
export async function getServerSideProps(context: GetServerSidePropsContext) {
  const {
    props: defaultProps
  } = await getDefaultServerSideProps({
    locale: context.locale,
    namespaces: ['classroom']
  });
  const rawCode = String(context.query.code ?? '');
  const initialCode = parseScannedCode(rawCode) ?? '';
  // code 파라미터는 있었지만 형식이 잘못돼 파싱에 실패한 경우 → 폼 폴백 시 토스트 안내.
  const hadInvalidCode = Boolean(rawCode) && !initialCode;
  return {
    props: {
      ...defaultProps,
      initialCode,
      rawCode,
      hadInvalidCode
    }
  };
}